<template>
  <div class="container">
    <div v-if="error.statusCode === 404">
      <center><h1>404 Not Found</h1></center>
      <hr><center>nginx/1.4.1</center>
    </div>
    <div v-else>
      服务异常，请检查网址是否正确
    </div>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  layout: 'errorLayout' // you can set a custom layout for the error page
};
</script>
